module.exports = __webpack_public_path__ + "img/coTChdrg.6b0523b4.svg";